/*  商品管理模块接口 */
const axios = require('axios')
// const qs = require('qs')
const Header = require('./auth')
const {
  GET_SHOPID_NAME_LIST_URL, GET_TABLE_LIST_URL, ADD_CATEGORIES_URL, CHANGE_CATEGORIES_STATUS_URL,
  DELETE_CATEGORIES_URL
} = require('./url')

/* 根据用户名获取店铺名 */
function getShopNameList ({ pageNum, pageSize, userName }) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.get(`${GET_SHOPID_NAME_LIST_URL}/${userName}/${pageNum}/${pageSize}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 根据店铺id获取表格数据 */
function getTableList (shopId) {
  // console.log(shopId)
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.get(`${GET_TABLE_LIST_URL}/${shopId}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 根据商品id和商品切换状态切换商品上下架状态 */
function changeCategoriesStatus (sendData) {
  // console.log(shopId)
  return new Promise((resolve, reject) => {
    axios.post(`${CHANGE_CATEGORIES_STATUS_URL}/${sendData.productId}/${sendData.status}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 通过商品ID删除商品 */
function deleteCategoriesId (id) {
  return new Promise((resolve, reject) => {
    axios.delete(`${DELETE_CATEGORIES_URL}/${id}`)
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
/* 增加一条商品记录 */
function addCategories (sendData) {
  Header.axiosStop()
  return new Promise((resolve, reject) => {
    axios.post(`${ADD_CATEGORIES_URL}/${sendData.shopId}`,
      {
        categoryId: sendData.categoryId, // 商品分类id
        mainImage: sendData.mainImage, // 商品图片
        detail: sendData.detail, // 商品详情
        // file: '', // 商品图片
        name: sendData.name, // 商品名称
        normalPrice: sendData.normalPrice, // 商品普通价格
        priority: sendData.priority, // 优先级
        promotionPrice: sendData.promotionPrice, // 商品促销价格
        sales: sendData.sales, // 商品销量
        status: sendData.status, // 商品状态（0：未上架， 1： 上架）
        stock: sendData.stock, // 库存数量
        subtitle: sendData.subtitle// 商品副标题
      }
    )
      .then(res => {
        // console.log(res)
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}
module.exports = {
  getShopNameList,
  getTableList,
  addCategories,
  changeCategoriesStatus,
  deleteCategoriesId
}
